import profileImage from "../profileImage.webp";

const experience = [
  {
    title: "Backend Development",
    text:
      "Designing maintainable REST APIs, business workflows, authentication systems and third-party integrations with Node.js.",
    color: "blue"
  },
  {
    title: "Data & Performance",
    text:
      "Working with PostgreSQL, MySQL, MongoDB and Redis while focusing on query efficiency, bulk processing and reliable data flows.",
    color: "cyan"
  },
  {
    title: "Scalable Architecture",
    text:
      "Building real-time and event-driven systems with node worker, Socket.IO, Kafka, Redis, RabbitMQ, microservices patterns, Docker and CI/CD.",
    color: "violet"
  }
];

const technologies = [
  "JavaScript",
  "Node.js",
  "Express.js",
  "TypeScript",
  "Next.js",
  "NestJS",
  "React",
  "PostgreSQL",
  "MySQL",
  "MongoDB",
  "Prisma",
  "Sequelize",
  "Redis",
  "Kafka",
  "RabbitMQ",
  "Socket.IO",
  "Node Worker",
  "Docker",
  "AWS",
  "Google Cloud",
  "GitHub Actions"
];

export default function About() {
  return (
    <section
      id="about"
      className="section section-alt"
    >
      <div className="container">

        {/* ================= SECTION HEADER ================= */}

        <div className="section-heading">

          <p className="section-kicker">
            About me
          </p>

          <h2>
            The developer behind the code.
          </h2>

          <p>
            A backend-focused engineer who enjoys
            turning complex requirements into clean
            APIs, reliable systems and scalable
            products.
          </p>

        </div>

        {/* ================= ABOUT INTRO ================= */}

        <div className="about-layout">

          <div className="about-card about-profile-card">

            <div className="about-profile">

              <div className="profile-photo-wrapper">

                <div
                  className="profile-photo-glow"
                  aria-hidden="true"
                />

                <div className="profile-photo-ring">

                  <img
                    src={profileImage}
                    alt="Akshay Prajapati - Backend Developer"
                    className="about-profile-photo"
                    loading="lazy"
                    decoding="async"
                  />

                </div>

                <div className="profile-status">

                  <span className="profile-status-dot" />

                  Open to opportunities

                </div>

              </div>

              <div className="about-profile-content">

                <div className="card-number">
                  01
                </div>

                <h3>
                  Hi, I'm Akshay Prajapati 👋
                </h3>

                <p className="about-role">
                  Backend Developer
                  <span> • </span>
                  Node.js
                  <span> • </span>
                  APIs
                  <span> • </span>
                  Cloud
                </p>

                <p>
                  I'm a Backend Developer with 3+
                  years of experience building
                  scalable and maintainable systems.
                  My primary focus is the Node.js
                  ecosystem, with hands-on experience
                  across databases, real-time
                  communication, integrations and
                  deployment.
                </p>

                <p>
                  I enjoy clean architecture,
                  practical system design and
                  measurable performance improvements.
                  I have worked on CRM workflows,
                  third-party APIs, reporting systems,
                  bulk spreadsheet processing,
                  emailing systems and real-time
                  applications.
                </p>

                <a
                  className="text-link"
                  href="https://github.com/akshayecs"
                  target="_blank"
                  rel="noreferrer"
                >
                  View my GitHub

                  <span aria-hidden="true">
                    ↗
                  </span>
                </a>

              </div>

            </div>

          </div>

          {/* ================= EXPERIENCE ================= */}

          <div className="about-grid">

            {experience.map(
              (item, index) => (
                <article
                  className={`mini-card mini-card-${item.color}`}
                  key={item.title}
                >

                  <span className="mini-card-number">
                    0{index + 2}
                  </span>

                  <h3>
                    {item.title}
                  </h3>

                  <p>
                    {item.text}
                  </p>

                </article>
              )
            )}

          </div>

        </div>

        {/* ================= TECH STACK ================= */}

        <div className="stack-panel">

          <div>

            <p className="section-kicker">
              Technical toolkit
            </p>

            <h3>
              Technologies I use to build
              and ship products.
            </h3>

          </div>

          <div className="stack-cloud">

            {technologies.map(
              (technology) => (
                <span key={technology}>
                  {technology}
                </span>
              )
            )}

          </div>

        </div>

      </div>
    </section>
  );
}